import styled from '@emotion/styled';
import { scrollbar } from 'src/assets/colors';

export const ScrollBar = styled('div', { label: 'ScrollBar' })`
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar-track {
        border-radius: 2px;
    }
    &::-webkit-scrollbar {
        background-color: ${scrollbar.bgColorSecondary};
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${scrollbar.bgColor};
        border-radius: 2px;
    }
    overflow: auto;
    scrollbar-color: ${scrollbar.bgColor} ${scrollbar.bgColorSecondary};
    scrollbar-width: thin;
`;

export const ScrollBarVertical = styled(ScrollBar, { label: 'ScrollBarVertical' })`
    overflow-x: hidden;
`;

export const ScrollBarHorizontal = styled(ScrollBar, { label: 'ScrollBarHorizontal' })`
    overflow-y: hidden;
`;

